import ErrorMessage from "components/ErrorMessage";
import Loader from "layout/Loader";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from 'react-select';
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import FormValidation from "utils/formValidation";
import helpers from "utils/helpers";
import PhoneInput from "react-phone-input-2";
import { isEmpty } from "lodash";
import FileUploadInput from "components/reusable/FileUploadInput";
import { apiGet, apiPost } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import axios from "axios";
import useToastContext from "hooks/useToastContext";
import AuthContext from "context/AuthContext";
import OImage from "components/reusable/OImage";
import ImageModal from "components/reusable/ImageModal";
import { MdArrowCircleRight } from "react-icons/md";
function Register() {
  const notification = useToastContext();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [countryCode] = useState("us");
  const inputRef = useRef(null);
  const [isRegisterData, setIsRegisterData] = useState(helpers.getLocalStorage('registerData'))
  const { updatePageName } = useContext(AuthContext);

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },

  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const {
    register: register1,
    handleSubmit: handleSubmit1,
    control: control1,
    reset: reset1,
    formState: { errors: errors1 },

  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const formValidation = FormValidation()
  const preventSpace = (e) => {
    if (e?.which === 32) {
      e.preventDefault();
    }
  };



  useEffect(() => {
    updatePageName("View Profile")
  }, [])
  const customStyles = {
    option: (provided) => ({
      ...provided,
      fontSize: '13px',
      zIndex: 9999
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: '14px',
    }),
    container: (provided) => ({
      ...provided,
      fontSize: '14px',
    }),
    control: (provided) => ({
      ...provided,
      minHeight: 53,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 999,
      top: '-5px'
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 999,
    }),

  };



  const handleFirstStep = (e) => {
    e.mobile = e?.mobile?.substring(inputRef?.current?.state.selectedCountry?.countryCode?.length, e?.mobile?.toString()?.length);
    e.countryCode = inputRef?.current?.state.selectedCountry?.countryCode;
    setIsRegisterData(e)
    helpers.setLocalStorage('registerData', e)
    helpers.setLocalStorage('steps', '2')
  }

  useEffect(() => {
    if (!isEmpty(isRegisterData)) {
      reset({ ...isRegisterData, mobile: helpers.ternaryCondition(isRegisterData?.countryCode, isRegisterData?.countryCode + isRegisterData?.mobile, "na") })
    }

  }, [isRegisterData])





  const readFileAsArrayBuffer = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  };


  const getPreSignUrl = async (file) => {
    try {
      const payloadPre = {
        contentType: file?.type,
      };
      const path = apiPath.generatePeoviderPreSignUrl;
      const result = await apiPost(path, payloadPre);
      if (result?.data?.success) {
        const buffer = await readFileAsArrayBuffer(file);
        const resp = await axios.put(result?.data?.results?.url, buffer, {
          headers: {
            "Content-Type": file.type || "application/octet-stream",
          },
        });

        if (resp?.status === 200) {
          return result?.data?.results;
        }
      }
    } catch (error) {
      console.error("--------error------------", error);
    }
  }


  const [isPending, setPending] = useState(false)
  const handleRegister = async (e) => {
    try {
      const files = {
        vehicleRegistrationFront: e.vehicleRegistrationFront?.[0],
        vehicleRegistrationBack: e.vehicleRegistrationBack?.[0],
        vehicleInsurancePolicy: e.vehicleInsurancePolicy?.[0],
        governmentIDFront: e.governmentIDFront?.[0],
        governmentIDBack: e.governmentIDBack?.[0],
        serviceCertificate: e.serviceCertificate?.[0],
      };

      const uploadedUrls = {
        vehicleRegistrationCertificateDocFront: '',
        vehicleRegistrationCertificateDocBack: '',
        vehicleInsurancePolicyDoc: '',
        governmentIDDocFront: '',
        governmentIDDocBack: '',
        serviceCertificationsDoc: '',
      };

      setPending(true)
      for (const key in files) {
        const file = files[key];

        if (file) {
          const presignedUrl = await getPreSignUrl(file);
          if (!presignedUrl?.key) {
            throw new Error(`Upload failed for ${key}`);
          }
          switch (key) {
            case 'vehicleRegistrationFront':
              uploadedUrls.vehicleRegistrationCertificateDocFront = presignedUrl.key;
              break;
            case 'vehicleRegistrationBack':
              uploadedUrls.vehicleRegistrationCertificateDocBack = presignedUrl.key;
              break;
            case 'vehicleInsurancePolicy':
              uploadedUrls.vehicleInsurancePolicyDoc = presignedUrl.key;
              break;
            case 'governmentIDFront':
              uploadedUrls.governmentIDDocFront = presignedUrl.key;
              break;
            case 'governmentIDBack':
              uploadedUrls.governmentIDDocBack = presignedUrl.key;
              break;
            case 'serviceCertificate':
              uploadedUrls.serviceCertificationsDoc = presignedUrl.key;
              break;
          }
        }
      }

      const payload = {
        IBANNumber: e?.IBANNumber,
        accountHolderName: e?.accountHolderName,
        accountNumber: e?.accountNumber,
        ...uploadedUrls,
        ...isRegisterData,
        specialtyServices: isRegisterData?.specialtyServices?.map((res) => res?.value)
      };

      const resp = await apiPost(apiPath.register, payload);
      if (resp?.data?.success) {
        notification.success(resp?.data?.message)
        navigate('/login')
        helpers.removeLocalStorage('registerData')
        helpers.removeLocalStorage('steps')
        setPending(false)
        return
      }
      notification.error(resp?.data?.message)
      setPending(false)

    } catch (err) {
      console.log('Error in handleRegister:', err);
      setPending(false)
    }

  };

  const [serviceCategory, setServiceCategory] = useState([])

  const getServiceCategory = async () => {
    try {

      const resp = await apiGet(apiPath.getMasterCategory)
      if (resp?.data?.success) {
        setServiceCategory(resp?.data?.results?.services?.map((res) => ({ label: res?.name, value: res?._id })))
        return
      }
      setServiceCategory([])
    } catch (err) {
      console.log('-----errr----', err)
    }

  }

  const [profileData, setProfileData] = useState()
  const [accountTypeData, setAccountTypeData] = useState('individual')
  const getProfileDetails = async () => {
    try {

      const resp = await apiGet(apiPath.getProfileData)
      if (resp?.data?.success) {

        const { licenseDocFront, licenseDocBack, truckDOTNumberDocBack, truckDOTNumberDocFront, businessRegistrationCertificateDocFront, businessRegistrationCertificateDocBack, companyInsurancePolicyDoc, } = resp?.data?.results
        reset({ ...resp?.data?.results, accountType: resp?.data?.results?.accountType, mobile: helpers.ternaryCondition(resp?.data?.results?.countryCode, resp?.data?.results?.countryCode + resp?.data?.results?.mobile, "na"),caNumber:resp?.data?.results?.caNumber, specialtyServices: resp?.data?.results?.specialtyServices?.map((res) => ({ value: res?._id, label: res?.name })) })
        reset1({ ...resp?.data?.results?.bankAccountDetails, governmentIDFront: licenseDocFront, governmentIDBack: licenseDocBack, serviceCertificate: truckDOTNumberDocFront, serviceCertificateBack: truckDOTNumberDocBack, vehicleRegistrationBack: businessRegistrationCertificateDocBack, vehicleRegistrationFront: businessRegistrationCertificateDocFront, vehicleInsurancePolicy: companyInsurancePolicyDoc })
        setProfileData(resp?.data?.results)
        setAccountTypeData(resp?.data?.results?.accountType)

        return
      }
      setServiceCategory([])
    } catch (err) {
      console.log('-----errr----', err)
    }

  }




  useEffect(() => {
    getServiceCategory()
    getProfileDetails()
  }, [])





  const handleStripeOnboarding = async () => {
    try {
      const res = await apiGet(apiPath.getProfileData + '/stripe-onboard-url');
      if (res?.data?.success) {
        console.log(
          "res.data.results",
          res.data.results
        );
        if (res.data.results?.accountLink) {
          window.open(res.data.results?.accountLink, '_self', 'noopener,noreferrer');
        } else {
          console.error('URL not found in response');
        }
      }
    } catch (error) {
      console.log("error>>", error.message);
    }
  };


  return (
    <div className="h-[856px] bg-gradient-to-br from-gray-100 to-gray-200 p-6">
      <Loader />
      {helpers.andOperator(isPending, <div id='loader' className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[999] ">
        <div className="w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        <span className='visually-hidden ml-2 text-gray-400'>Loading...</span>
      </div>)}
      <div className="max-w-6xl mx-auto  bg-white rounded-2xl shadow-xl mt-8 space-y-6 overflow-hidden">

        <div className="max-h-[770px] overflow-y-auto p-6 md:p-10">
          <div className="register-form bg-white  rounded-[20px] overflow-hidden  ">
            <div className="bg-[#F3F3F3] p-6 sm:flex">
              <h4 className="text-xl mb-3 font-bold text-[#151513]">
                View Profile
              </h4>

              {(profileData && !profileData?.isStripeProfileCompleted) ? <button
                className="bg-gradientTo cursor-pointer text-xs flex m-auto  text-white active:bg-emerald-600 font-normal text-sm px-8 py-2 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150"
                type="submit"
                onClick={handleStripeOnboarding}
              >
                {t("COMPLETE_STRIPE_ONBOARDING")}
              </button> :
                (profileData?.stripeLoginLink && profileData?.isStripeProfileCompleted) ?
                  <Link
                    to={profileData?.stripeLoginLink}
                    target="__blank"
                    className="bg-gradientTo cursor-pointer text-xs flex m-auto  text-white active:bg-emerald-600 font-normal text-sm px-8 py-2 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150"
                   
                  >
                    {t("Stripe Login")} <MdArrowCircleRight size={18}  className="mx-1" />

                  </Link> : ''}

            </div>

            <div className="flex justify-center mt-4">
              <ImageModal
                url={profileData?.profilePic || '/images/user2.png'}
                title={"Profile Picture"}
              >
                <OImage src={profileData?.profilePic || '/images/user2.png'} className='h-20 w-[90px]  rounded-2xl' />
              </ImageModal>
            </div>


            <form className="" onSubmit={handleSubmit(handleFirstStep)}>
              <div className="p-6">
                <div className="mb-7">
                  <div className="flex mb-2">
                    <div className="flex items-center  me-6">
                      <input
                        name='accountType'
                        id="radio1"
                        type="radio"
                        value="individual"
                        disabled
                        className="w-5 h-5 peer opacity-0"
                        checked={accountTypeData === "individual"}

                      />
                      <span className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center relative after:bg-[#E89F34] after:w-3 after:h-3 after:rounded-full after:opacity-0 peer-checked:border-[#E89F34] peer-checked:after:opacity-100 -ms-5">
                      </span>
                      <label
                        htmlFor="radio1"
                        className="ms-2 text-sm cursor-pointer text-gray-900 dark:text-gray-900"
                      >
                        Individual
                      </label>
                    </div>

                    <div className="flex items-center">
                      <input
                        name='accountType'
                        id="radio"
                        type="radio"
                        value="company"
                        disabled
                        className="w-5 h-5 peer opacity-0"
                        checked={accountTypeData === "company"}
                      />
                      <span className="w-5 h-5 rounded-full  border border-gray-400 flex items-center justify-center relative after:bg-[#E89F34] after:w-3 after:h-3 after:rounded-full after:opacity-0 peer-checked:border-[#E89F34] peer-checked:after:opacity-100 -ms-5">
                      </span>
                      <label
                        htmlFor="radio"
                        className="ms-2 text-sm text-gray-900 cursor-pointer dark:text-gray-900"
                      >
                        Company
                      </label>
                    </div>
                  </div>
                  <ErrorMessage message={errors?.accountType?.message} />
                </div>

                <div className="sm:grid grid-cols-3 gap-6">

                  <div className="relative z-0 w-full group mb-3 sm:mb-0">
                    <input
                      type="text"
                      id="fullName"
                      disabled
                      className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                      name="fullName"
                      {...register("fullName",
                        formValidation.fullNameSP)}
                    />

                    <label
                      htmlFor="fullName"
                      className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                      {t("OWNERS_FULL_NAME")}
                      <span className="text-red-500">*</span>
                    </label>
                    <ErrorMessage message={errors?.fullName?.message} />
                  </div>

                 <div className="relative z-0 w-full group mb-3 sm:mb-0">
                    <input
                      type="text"
                      id="companyName"
                      disabled
                      className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                      name="companyName"
                      {...register("companyName",
                        accountTypeData == 'company' ? formValidation.companyName : {})}
                    />

                    <label
                      htmlFor="companyName"
                      className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                    >
                      {t("COMPANY_NAME")}
                      <span className="text-red-500">*</span>
                    </label>
                    <ErrorMessage message={errors?.companyName?.message} />
                  </div>


                  <div className="relative z-0 w-full group mb-3 sm:mb-0 z-50">
                    <Controller
                      control={control}
                      disabled
                      name="mobile"
                      rules={{
                        required: "Please enter mobile no.",
                        validate: (value) => {
                          const inputValue = value?.toString()?.slice(inputRef?.current?.state?.selectedCountry?.countryCode?.length, value?.length);
                          if (inputValue?.length < 7) {
                            return "Mobile no. must be greater than 7 digits.";
                          } else if (inputValue?.length > 12) {
                            return "Mobile no. should be not exceed 15 digits.";
                          }
                        },
                      }}
                      render={({ field: { ref, ...field } }) => (
                        <PhoneInput
                          {...field}
                          inputExtraProps={{
                            ref,
                            required: true,
                            autoFocus: true,
                          }}
                          ref={inputRef}
                          inputStyle={{
                            width: "100%",
                            height: "54px",
                          }}

                          style={{ borderRadius: "20px" }}
                          country={countryCode}
                          enableSearch={false}
                          onlyCountries={["us"]}
                          countryCodeEditable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.mobile?.message} />
                  </div>

                  <div className="relative z-0 w-full group mb-3 sm:mb-0">
                    <input
                      type="text"
                      id="email"
                      className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                      name="email"
                      disabled
                      onKeyDown={(e) => preventSpace(e)}
                      {...register("email",
                        formValidation.email)}
                    />

                    <label
                      htmlFor="email"
                      className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                    >
                      {t("O_EMAIL_ID")}
                      <span className="text-red-500">*</span>
                    </label>
                    <ErrorMessage message={errors?.email?.message} />
                  </div>


                  <div className="relative z-0 w-full group mb-3 sm:mb-0">
                      <input
                        type={"text"}
                        name="caNumber"
                        id="caNumber"
                        maxLength={40}
                        disabled
                        className="e block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        autoComplete="caNumber"
                        {...register("caNumber",formValidation.caNumberSP )}
                      />
                      <label
                        htmlFor="caNumber"
                        className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                        >
                        {t("CA_NUMBER")}
                        <span className="text-red-500">*</span>
                      </label>
                     
                      <ErrorMessage message={errors?.caNumber?.message} />
                    </div>


                    <div className="relative z-0 w-full group mb-3 sm:mb-0">
                      <input
                        type={"text"}
                        name="truckDOTNumber"
                        id="truckDOTNumber"
                        maxLength={40}
                        disabled
                        className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        autoComplete="truckDOTNumber"
                        {...register("truckDOTNumber",formValidation.truckDOTNumber )}
                      />
                      <label
                        htmlFor="truckDOTNumber"
                        className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                        >
                        {t("TRUCK_DOT_NUMBER")}
                        <span className="text-red-500">*</span>
                      </label>
                     
                      <ErrorMessage message={errors?.truckDOTNumber?.message} />
                    </div>
                  {/* <div className="relative z-0 w-full group mb-3 sm:mb-0">
                    <Controller
                      name="specialtyServices"
                      control={control}
                      rules={{ required: 'Please select at least one service.' }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={serviceCategory}
                          isMulti
                          placeholder={`Select Specialty Services*`}
                          classNamePrefix="react-select"
                          className="react-select-container "
                          styles={customStyles}
                          isDisabled
                          menuPortalTarget={document.body}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.specialtyServices?.message} />
                  </div> */}

                  <div className="relative z-0 w-full group mb-3 sm:mb-0">
                    <input
                      type="number"
                      name="yearOfExperience"
                      id="yearOfExperience"
                      disabled
                      className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                      step={0.1}
                      {...register("yearOfExperience", {
                        required: false,
                        max: { value: 100, message: 'Year of experience cannot greater than 100.' },
                        min: { value: 0.1, message: 'Year of experience must be greater than 0.' },

                        onChange: (e) => {
                          let value = e.target.value;
                          value = value.replace(/[^0-9.]/g, '');
                          const parts = value.split('.');
                          if (parts.length > 2) {
                            value = parts[0] + '.' + parts[1];
                          }
                          if (parts[1]) {
                            value = parts[0] + '.' + parts[1].slice(0, 2);
                          }

                          e.target.value = value;
                        }

                      })}
                      onKeyDown={(e) => {
                        if ([",", "e", "-"].includes(e.key)) e.preventDefault();
                      }}
                    />
                    <label
                      htmlFor="yearOfExperience"
                      className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                    >
                      {t("Years of Experience")}
                      <span className="text-red-500">*</span>
                    </label>

                    <ErrorMessage message={errors?.yearOfExperience?.message} />
                  </div>


                  <div className="relative z-0 w-full group mb-3 sm:mb-0">
                    <textarea
                      name="address"
                      id="address"
                      disabled
                      className=" block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                      {...register("address", {
                        required: "Please enter address.",
                        validate: {
                          whiteSpace: (value) => value.trim() ? true : t('WHITE_SPACES_NOT_ALLOWED')
                        },
                        minLength: { value: 2, message: 'Addres must be greater than 2 characters.' },
                        maxLength: { value: 300, message: 'Addres must be less than 300 characters.' }

                      })}
                    />
                    <label
                      htmlFor="address"
                      className=" dark:text-gray-500 peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                    >
                      {t("SEARCH_LOCATION")}
                      <span className="text-red-500">*</span>
                    </label>
                    <ErrorMessage message={errors?.address?.message} />
                  </div>

                </div>
              </div>

            </form>

            <form className="" onSubmit={handleSubmit1(handleRegister)}>
              <div className="p-6 ">
                <div className="sm:grid grid-cols-3 gap-6">
                
                    <div>
                      <h4 className="mb-1 font-bold text-[#151513]">
                        Business Registration Certificate
                      </h4>
                      <p className="text-sm">
                        Current business registration certificate for your services
                      </p>
                      <div className="flex flex-wrap md:grid grid-cols-3 gap-3 pt-2">
                        <div>
                          <FileUploadInput
                            label="Upload Front"
                            name="vehicleRegistrationFront"
                            control={control1}
                            rules={{
                              required: "Business registration certificate (front) is required.",
                              validate: {
                                acceptedFormats: (file) =>
                                  file && ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                  || "Only JPG, PNG,files are allowed.",
                                fileSize: (file) =>
                                  file && file[0]?.size <= 5 * 1024 * 1024 || "File must be less than 5MB."
                              }
                            }}
                            accept=".jpg,.jpeg,.png"
                            isView={true}
                          />

                        </div>

                        <div>
                          <FileUploadInput
                            label="Upload Back"
                            name="vehicleRegistrationBack"
                            control={control1}
                            rules={{
                              required: "Business registration certificate (back) is required.",
                              validate: {
                                acceptedFormats: (file) =>
                                  file && ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                  || "Only JPG, PNG,files are allowed.",
                                fileSize: (file) =>
                                  file && file[0]?.size <= 5 * 1024 * 1024 || "File must be less than 5MB."
                              }
                            }}
                            accept=".jpg,.jpeg,.png"
                            isView={true}
                          />


                        </div>
                      </div>
                      <ErrorMessage message={errors1?.vehicleRegistrationFront?.message} />
                      <ErrorMessage message={errors1?.vehicleRegistrationBack?.message} />
                    </div>

                    <div>
                      <h4 className="mb-1 font-bold text-[#151513]">
                        Company Insurance Policy
                      </h4>
                      <p className="text-sm">
                        Valid Company insurance policy document showing coverage details
                      </p>

                      <div className="flex flex-wrap md:grid grid-cols-3 gap-3 pt-2">
                        <div>
                          <FileUploadInput
                            label="Upload PDF"
                            name="vehicleInsurancePolicy"
                            control={control1}
                            rules={{
                              required: "Company Insurance Policy is required.",
                              validate: {
                                acceptedFormats: (file) =>
                                  file && ["application/pdf"].includes(file[0]?.type)
                                  || "Only PDF file is allowed.",
                                fileSize: (file) =>
                                  file && file[0]?.size <= 10 * 1024 * 1024 || "File must be less than 10MB."
                              }
                            }}
                            accept=".pdf"
                            fileType='pdf'
                            isView={true}
                          />

                        </div>
                      </div>
                      <ErrorMessage message={errors1?.vehicleInsurancePolicy?.message} />
                    </div>
                 

                  <div>
                    <h4 className="mb-1 font-bold text-[#151513]">
                    Owner’s Driving License
                    </h4>
                    <p className="text-sm">
                      Valid government-issued identification document
                    </p>
                    <div className="flex flex-wrap md:grid grid-cols-3 gap-3 pt-2">
                      <div>
                        <FileUploadInput
                          label="Upload Front"
                          name="governmentIDFront"
                          control={control1}
                          rules={{
                            required: "Government ID (front) is required.",
                            validate: {
                              acceptedFormats: (file) =>
                                file && ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                || "Only JPG, PNG,files are allowed.",
                              fileSize: (file) =>
                                file && file[0]?.size <= 5 * 1024 * 1024 || "File must be less than 5MB."
                            }
                          }}
                          accept=".jpg,.jpeg,.png"
                          isView={true}
                        />

                      </div>

                      <div>
                        <FileUploadInput
                          label="Upload Back"
                          name="governmentIDBack"
                          control={control1}
                          rules={{
                            required: "Government ID (back) is required.",
                            validate: {
                              acceptedFormats: (file) =>
                                file && ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                || "Only JPG, PNG,files are allowed.",
                              fileSize: (file) =>
                                file && file[0]?.size <= 5 * 1024 * 1024 || "File must be less than 5MB."
                            }
                          }}
                          accept=".jpg,.jpeg,.png"
                          isView={true}

                        />


                      </div>
                    </div>
                    <ErrorMessage message={errors1?.governmentIDFront?.message} />
                    <ErrorMessage message={errors1?.governmentIDBack?.message} />
                  </div>

                  {/* <div>
                    <h4 className="mb-1 font-bold text-[#151513]">
                      Truck DOT Number Certifications
                    </h4>
                    <p className="text-sm">
                      Truck DOT Number certifications for your services
                    </p>

                    <div className="flex flex-wrap md:grid grid-cols-3 gap-3 pt-2">
                      <div>
                        <FileUploadInput
                          label="Upload Front"
                          name="serviceCertificate"
                          control={control1}
                          rules={{
                            required: "Truck dot number certificate (front) is required.",
                            validate: {
                              acceptedFormats: (file) =>
                                file && ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                || "Only JPG, PNG,files are allowed.",
                              fileSize: (file) =>
                                file && file[0]?.size <= 5 * 1024 * 1024 || "File must be less than 5MB."
                            }
                          }}
                          accept=".jpg,.jpeg,.png"
                          isView={true}
                        />


                      </div>

                      <div>
                        <FileUploadInput
                          label="Upload Back"
                          name="serviceCertificateBack"
                          control={control1}
                          rules={{
                            required: "Truck dot number certificate (back) is required.",
                            validate: {
                              acceptedFormats: (file) =>
                                file && ["image/jpg", "image/png", "image/jpeg"].includes(file[0]?.type)
                                || "Only JPG, PNG,files are allowed.",
                              fileSize: (file) =>
                                file && file[0]?.size <= 5 * 1024 * 1024 || "File must be less than 5MB."
                            }
                          }}
                          accept=".jpg,.jpeg,.png"
                          isView={true}
                        />


                      </div>
                    </div>
                    <ErrorMessage message={errors1?.serviceCertificate?.message} />
                    <ErrorMessage message={errors1?.serviceCertificateBack?.message} />
                  </div> */}
                </div>
                {/* <div className="py-2">
                  <h4 className="mb-1 font-bold text-[#151513]">
                    Bank Details
                  </h4>
                  <p className="text-sm">
                    Bank Details for your services
                  </p>

                  <div className="md:grid grid-cols-2 gap-5 pt-4">


                    <div className="relative z-0 w-full group mb-3 sm:mb-0">
                      <input
                        type="text"
                        id="swiftCode"
                        className=" dark:text-white block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                        placeholder=""
                        disabled
                        name="swiftCode"
                        {...register1("swiftCode",
                          formValidation.accountHolderName)}
                      />

                      <label
                        htmlFor="swiftCode"
                        className=" dark:text-white peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-slate-900 p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("ACCOUNT_HOLDER_NAME")}
                        <span className="text-red-500">*</span>
                      </label>
                      <ErrorMessage message={errors1?.swiftCode?.message} />
                    </div>

                    <div className="relative z-0 w-full group mb-3 sm:mb-0">
                      <input
                        type="text"
                        id="accountNumber"
                        className=" dark:text-white block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                        placeholder=""
                        maxLength={20}
                        disabled
                        name="accountNumber"
                        {...register1("accountNumber",
                          {
                            required: 'Please enter account number.',
                            maxLength: { value: 16, message: 'Account number cannot be greater than 16 numbers.' },
                            minLength: { value: 8, message: 'Account number must be greater than 8.' },
                            onChange: (e) => { e.target.value = e?.target?.value?.replace(/\D/g, ""); },

                          })}
                        onKeyDown={(e) => {
                          if ([".", ",", "e", "-"].includes(e.key)) e.preventDefault();
                        }}
                      />

                      <label
                        htmlFor="accountNumber"
                        className=" dark:text-white peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-slate-900 p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("ACCOUNT_NUMBER")}
                        <span className="text-red-500">*</span>
                      </label>
                      <ErrorMessage message={errors1?.accountNumber?.message} />
                    </div>

                    <div className="relative z-0 w-full group mb-3 sm:mb-0">
                      <input
                        type="text"
                        id="routingNumber"
                        maxLength={10}
                        className=" dark:text-white block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-[#DFDFDF]  focus:outline-none focus:ring-0  peer"
                        placeholder=""
                        disabled
                        name="routingNumber"
                        {...register1("routingNumber",
                          {
                            required: 'Please enter routing number.',
                            maxLength: { value: 8, message: 'Routing number cannot be greater than 8 alphanumeric.' },
                            minLength: { value: 4, message: 'Routing number must be greater than 4 alphanumeric.' },
                            onChange: (e) => { e.target.value = e?.target?.value?.replace(/[^a-zA-Z0-9]/g, '')?.toUpperCase(); },

                          })}
                        onKeyDown={(e) => {
                          if ([".", ",", "e", "-"].includes(e.key)) e.preventDefault();
                        }}

                      />

                      <label
                        htmlFor="routingNumber"
                        className=" dark:text-white peer-focus:font-normal absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white dark:bg-slate-900 p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {t("Routing Number")}
                        <span className="text-red-500">*</span>
                      </label>
                      <ErrorMessage message={errors1?.routingNumber?.message} />
                    </div>
                  </div>
                </div> */}
              </div>

            </form>
          </div>
        </div>

      </div>
    </div >
  );
}

export default Register;
